import { Controller } from '@hotwired/stimulus';

export default class carousel extends Controller {
  static targets = ["carousel", "leftArrow", "rightArrow"];

  connect() {
    // Initialize anything per instance here
    this.count = 0;
    this.animationTimeOut = 1000;

    const firstArticle = this.carouselTarget.querySelector(".s-carousel-item article");

    if (firstArticle) {
      firstArticle.classList.add("first-item");
      const parentItem = firstArticle.closest('.s-carousel-item');
      if (parentItem) {
        parentItem.classList.add("active-carousel-card");
      }
    }
  }

	handleScrollRight(event) {
    const carousel = this.carouselTarget;
    const leftArrow = this.leftArrowTarget;
    const carouselItems = carousel.querySelectorAll(".s-carousel-item");
    const carouselCardsList = carousel.parentNode.querySelector('.s-carousel__cards__list');
    const totalCarouselItems = Object.keys(carouselItems).length;

    if (this.count === 0) {
      carousel.classList.add("sliding-transition");
      carouselCardsList.style.overflow = "visible";
      carousel.style.transform = `translateX(-${(carouselItems[1].clientWidth + 32)}px)`;
    }
    else {
      for (let i = 0; i < carouselItems.length; i++) {
        carouselItems[i].classList.add("sliding-transition");
        carouselItems[i].style.transform = `translateX(-${(carouselItems[1].clientWidth + 32)}px)`;
      }
    }

    setTimeout(() => {
      carousel.appendChild(carouselItems[0]);
      const imagePlaceholder = carousel.querySelectorAll(".carousel-image-placeholder");
      if (imagePlaceholder[0]) {
        carousel.removeChild(imagePlaceholder[0]);
      }
      const activeElement = carousel.querySelector(".active-carousel-card.s-carousel-item");
      activeElement.classList.remove('active-carousel-card');
      carousel.children[1].classList.add("active-carousel-card");
      if(this.count === 0) {
        carousel.classList.remove("sliding-transition");
      }
      else {
        for (let i = 0; i < carouselItems.length; i++) {
          carouselItems[i].classList.remove("sliding-transition");
          carouselItems[i].style.transform = `translateX(0px)`;
        }
      }
      this.count++;
      leftArrow.setAttribute('disabled', 'false');
    }, this.animationTimeOut);
    event.stopPropagation();
  }

  handleScrollLeft(event) {
    const carousel = this.carouselTarget;
    const leftArrow = this.leftArrowTarget;

    if (leftArrow.getAttribute('disabled') === 'true') {
      return;
    }

    const firstItem = carousel.querySelector(".first-item");
    var arr = Array.prototype.slice.call(carousel.children);
    arr.indexOf(carousel.children[0].querySelector(".first-item"))
  
    var parent = firstItem.parentNode;
    var index = arr.indexOf(parent);
  
    if (index === 0) {
      const imagePlaceholder = document.createElement("div");
      imagePlaceholder.setAttribute('class', 'carousel-image-placeholder s-carousel-item grid__cell size--10-12@sm size--10-12@md size--5-12@lg');
      carousel.appendChild(imagePlaceholder);
    }
  
    if (leftArrow.getAttribute('disabled') == 'true') {
      return; 
    }
    this.count--;
    const carouselItems = carousel.querySelectorAll(".s-carousel-item");
    const totalCarouselItems = Object.keys(carouselItems).length;
    let currentIndex = (totalCarouselItems - 1) % totalCarouselItems;
    if (this.count !== 0)  {
      for (let i = 0; i < carouselItems.length; i++) {
        carouselItems[i].classList.add("sliding-transition-left");
        carouselItems[i].style.transform = `translateX(${(carouselItems[1].clientWidth + 32)}px)`;
      }
    }
  
    const cardItemsCount = Array.from(carouselItems).filter(item => !item.classList.contains('carousel-image-placeholder')).length;

    setTimeout(() => { 
      if (carousel.querySelectorAll(".carousel-image-placeholder")[0]){
        leftArrow.setAttribute('disabled', 'true');

        if(this.count === 0) {
          carousel.classList.add("sliding-transition");
          carousel.style.transform = `translateX(0px)`;
        }
      }
      const activeElement = carousel.querySelector(".active-carousel-card.s-carousel-item");
      activeElement.classList.remove('active-carousel-card');

      carousel.children[1].classList.add("active-carousel-card");
    }, 10);
  
    setTimeout(() => {
      carousel.insertBefore(carouselItems[currentIndex], carousel.firstChild);

      if(this.count % cardItemsCount === 0) {
        this.count = 0;
      }

      if(this.count === 0) {
        carousel.classList.remove("sliding-transition");
        carousel.style.transform = `translateX(0px)`;
      }
      for (let i = 0; i < carouselItems.length; i++) {
        carouselItems[i].classList.remove("sliding-transition-left");
        carouselItems[i].style.transform = `translateX(0px)`;
      }
    }, this.animationTimeOut);
    event.stopPropagation();
  }
}